import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0 },
};

export default function RetreatPreview() {
  const scrollToRegister = () => {
    document.getElementById("register")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="retreat"
      data-testid="retreat-preview-section"
      className="relative py-24 md:py-32 overflow-hidden"
    >
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://i.ontraport.com/260712.155544a5758d1d35b09cacdf90ad353f.PNG')`,
        }}
      />
      <div className="absolute inset-0 bg-black/65" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          {/* Glassmorphism card */}
          <motion.div
            className="md:col-span-7 md:col-start-6 bg-background/70 backdrop-blur-xl border border-white/5 shadow-2xl p-8 md:p-12"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={fadeUp}
            transition={{ duration: 0.6 }}
          >
            <span className="text-xs font-semibold tracking-[0.2em] uppercase text-primary mb-4 block font-['Outfit']">
              About the Retreat
            </span>
            <h2 className="text-3xl md:text-4xl font-light tracking-tight leading-tight mb-6">
              Just Be: Soft Power<br />Costa Rica Retreat
            </h2>
            <p className="text-base md:text-lg font-['Outfit'] font-light leading-relaxed text-foreground/75 mb-6">
              The Soft Power: "Just Be" Costa Rica Retreat is a curated experience designed
              for women seeking rest, restoration, sisterhood, and elevation for their highest
              and best next level.
            </p>
            <p className="text-base md:text-lg font-['Outfit'] font-light leading-relaxed text-foreground/75 mb-8">
              Whether you are seriously considering the retreat or simply want to come experience
              the energy in the room, we would love to welcome you to this evening preview.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                data-testid="retreat-rsvp-btn"
                onClick={scrollToRegister}
                className="rounded-none bg-primary text-primary-foreground hover:bg-primary/90 uppercase tracking-[0.2em] text-xs h-12 px-8"
              >
                Reserve Your Spot
              </Button>
              <a
                href="https://sisterdiamonds.com/costa-rica-retreat?ref=ANTONIO"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center rounded-none border border-white/20 text-foreground hover:border-primary hover:text-primary uppercase tracking-[0.2em] text-xs h-12 px-8 transition-colors font-['Outfit']"
                data-testid="retreat-learn-more-link"
              >
                Learn More
              </a>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Additional image overlay */}
      <motion.div
        className="hidden md:block absolute left-12 lg:left-24 top-1/2 -translate-y-1/2 w-[280px] lg:w-[340px] z-10"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
        variants={fadeUp}
        transition={{ duration: 0.6, delay: 0.2 }}
      >
        <div className="aspect-[3/4] overflow-hidden border border-white/10 shadow-2xl">
          <img
            src="https://i.ontraport.com/260712.726717efdfdf89ec33f8e110c365b47c.PNG"
            alt="Crystal and Dr. Nicole under flower arch"
            className="w-full h-full object-cover"
          />
        </div>
      </motion.div>
    </section>
  );
}
